import React from 'react';
import {currencyFormat} from '../../utils/functions/Functions';
import './DealerInquirySummary.css';

function DealerInquirySummary({customerData}) {
  return (
    <div className='prequal--web--fomo--dealer-form-display-container'>
      <div className='prequal--web--inquiry-title-text prequal--web--fomo--section-title'>Inquiry Summary</div>
      <div className='prequal--web--section-line stretch-hr' />
      <div className='prequal--web--dealer-form-section-title-container'>
        <span className='prequal--web--fomo--form-section-title'>Contact Info</span>
      </div>
      <div className='prequal--web--dealer-data-display-container'>
        <div className='prequal--web--display-data'>
          <span className='prequal-fomo-title'>Customer Name</span>
          <span className='prequal--web--fomo--value-field'>
            {customerData?.firstName?.value} {customerData?.lastName?.value}
          </span>
        </div>
        <div className='prequal--web--display-data'>
          <span className='prequal-fomo-title'>Email Address</span>
          <span className='prequal--web--fomo--value-field'>{customerData?.email?.value}</span>
        </div>
        <div className='prequal--web--display-data'>
          <span className='prequal-fomo-title'>Phone Number</span>
          <span className='prequal--web--fomo--value-field'>
            {customerData?.phoneNumber?.value ? customerData?.phoneNumber?.value : 'n/a'}
          </span>
        </div>
        <div className='prequal--web--display-data'>
          <span className='prequal-fomo-title'>Preferred Contact Method</span>
          <span className='prequal--web--fomo--value-field'>{customerData?.preferredContactMethod?.value}</span>
        </div>
      </div>
      <div className='prequal--web--section-line' />
      {customerData?.showPreQualificationAmount?.value ? (
        <>
          <div className='prequal--web--dealer-form-section-title-container'>
            <span className='prequal--web--fomo--form-section-title'>Prequalification Details</span>
          </div>
          <div className='prequal--web--dealer-data-display-container'>
            <div className='prequal--web--display-data'>
              <span className='prequal-fomo-title'>Total Prequalification Amount</span>
              <span className='prequal--web--fomo--value-field'>
                {customerData?.totalApprovedAmount?.value
                  ? currencyFormat(customerData.totalApprovedAmount.value)
                  : 'ERROR: Could not find approved amount please contact support'}
              </span>
            </div>
          </div>
          <div className='prequal--web--section-line' />
        </>
      ) : (
        <></>
      )}
      <div className='prequal--web--dealer-data-display-container'>
        <span className='prequal--web--fomo--form-section-title'>Notes to Dealer</span>
        <span className='prequal--web--fomo--value-field'>
          {customerData?.dealerNotes?.value ? customerData?.dealerNotes?.value : 'n/a'}
        </span>
      </div>
    </div>
  );
}

export default DealerInquirySummary;
